import { render } from "./TheTruongQGGD2.vue?vue&type=template&id=e1fa1cda"
import script from "./TheTruongQGGD2.vue?vue&type=script&lang=js"
export * from "./TheTruongQGGD2.vue?vue&type=script&lang=js"

import "./TheTruongQGGD2.vue?vue&type=style&index=0&id=e1fa1cda&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__